import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import FEATURES_CONFIG from 'config/features';
import { IAppState } from 'config/redux/reducers';
import EPaymentMethods from '../../PamentMethods.enum';
import CashOnDeliveryItem from '../CashOnDeliveryItem';
import CreditCardItem from '../CreditCardItem';
import MobileWalletTag from '../MobileWallet/MobileWalletTag';
import NewCreditCardItem from '../NewCreditCardItem';
import CardOnDeliveryItem from '../CardOnDeliveryItem';

const { enableHostedCreditCard } = FEATURES_CONFIG.settings;

interface IProps {
  paymentMethod: string;
  cardData?: any;
}

const PaymentRadioCardHeader: React.FC<IProps> = ({ paymentMethod, cardData = {} }) => {
  const { t } = useTranslation();

  const { countryConfiguration: { creditCardSubtitle = '' } = {} } = useSelector(
    (state: IAppState) => state.appConfig
  );

  if (paymentMethod === EPaymentMethods.CREDIT_CARD && cardData.id && !enableHostedCreditCard) {
    return (
      <CreditCardItem
        card={cardData}
        creditCardSubtitle={creditCardSubtitle}
        expired={cardData.isExpired}
      />
    );
  }

  if (paymentMethod === EPaymentMethods.CREDIT_CARD && !cardData.id && !enableHostedCreditCard) {
    return <NewCreditCardItem title={t('addCardDetails')} subTitle={creditCardSubtitle} />;
  }

  if (paymentMethod === EPaymentMethods.CREDIT_CARD && enableHostedCreditCard) {
    return <NewCreditCardItem title={t('creditCard')} subTitle={t('bankRedirection')} />;
  }

  if (paymentMethod === EPaymentMethods.DEBIT_CARD) {
    return <NewCreditCardItem title={t('addDebitCard')} subTitle={t('bankRedirection')} />;
  }

  if (paymentMethod === EPaymentMethods.COD) {
    return <CashOnDeliveryItem />;
  }

  if (paymentMethod === EPaymentMethods.CARD_ON_DELIVERY) {
    return <CardOnDeliveryItem />;
  }

  if (paymentMethod === EPaymentMethods.MOBILE_WALLET) {
    return <MobileWalletTag />;
  }

  return <></>;
};

export default PaymentRadioCardHeader;
